import { Link } from 'react-router-dom';

export function Wordmark() {
  return (
    <Link to="/" className="wordmark" aria-label="3DSpin home">
      <svg className="wordmark__symbol" viewBox="0 0 32 32" aria-hidden>
        <circle cx="16" cy="16" r="13" fill="none" stroke="#E60023" strokeWidth="2" />
        <circle cx="16" cy="16" r="4" fill="#E60023" />
        <ellipse cx="16" cy="16" rx="13" ry="5" fill="none" stroke="#111" strokeWidth="1.5" transform="rotate(-20 16 16)" />
      </svg>
      <span>
        3D<span className="wordmark__accent">Spin</span>
      </span>
    </Link>
  );
}
